import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';

import { Colors } from '@/assets';
import { INavItem } from '@/types';

interface IProps {
    item: INavItem;
    active?: boolean;
    onClick?: () => void;
}
export const NavItem: FC<IProps> = ({ item, active, onClick }) => {
    return (
        <Button
            onClick={onClick}
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                p: 1.5,
                gap: 1,
                boxShadow: 'none',
                background: active ? Colors.magnoliaWhite : 'transparent'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    gap: 1.5,
                    'svg > path': {
                        stroke: active ? Colors.mediumSlateViolet : Colors.lynchBlue
                    },
                    i: {
                        color: active ? Colors.mediumSlateViolet : Colors.lynchBlue,
                        fontSize: '2.3rem',
                        width: '2.3rem'
                    }
                }}
            >
                {item.icon}
                <Typography variant="h6" sx={{ fontWeight: 500, color: active ? Colors.slateBlueViolet : Colors.cloudBurstBlue }}>
                    {item.title}
                </Typography>
            </Box>
            {item.news && (
                <Box
                    sx={{
                        borderRadius: '1.6rem',
                        background: active ? Colors.quartzWhite : Colors.solitudeBlue,
                        px: 1.2,
                        py: 0.2,
                        color: Colors.slateBlueViolet
                    }}
                >
                    {item.news}
                </Box>
            )}
        </Button>
    );
};
